import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=59e58919&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "../../../style/common-pc.scss?vue&type=style&index=0&id=59e58919&prod&lang=scss&scoped=true&external"
import style1 from "../../../style/exchange-shop/pc/common.scss?vue&type=style&index=1&id=59e58919&prod&lang=scss&scoped=true&external"
import style2 from "./orderList.vue?vue&type=style&index=2&id=59e58919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e58919",
  null
  
)

export default component.exports